import { updateAppUserState } from "@ch/redux-store/user/actions";
import localforage from "localforage";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getCookie } from "../utils/cookies";
import { StorageNamesEnum } from "../utils/enums";

const useRestoreUserSession = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);

  void (async () => {
    // Check if user is logged in for the current browser session
    const cookieLoggedIn = getCookie(StorageNamesEnum.IS_LOGGED_IN);

    // Check if user selected remember me
    // Which saves the loggedIn state in permanent storage
    const isLocalStorageLoggedIn = await localforage.getItem(
      StorageNamesEnum.IS_LOGGED_IN,
    );

    const isUserLoggedIn = cookieLoggedIn === "true" || isLocalStorageLoggedIn;

    if (isUserLoggedIn) {
      dispatch(
        updateAppUserState({
          isLoggedIn: true,
        }),
      );
    } else {
      dispatch(
        updateAppUserState({
          isLoggedIn: false,
        }),
      );
    }
  })();

  useEffect(() => {
    const timeoutID = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => {
      clearTimeout(timeoutID);
    };
  }, []);

  return {
    isLoading,
  };
};

export default useRestoreUserSession;
